import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, NbLayoutModule, NbButtonModule, NbSidebarModule, NbMenuModule, NbToggleModule, NbContextMenuModule, NbActionsModule, NbSearchModule, NbIconModule, NbCardModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { KontosComponent } from './kontos/kontos.component';
import { BuchungenComponent } from './buchungen/buchungen.component';
import { HttpClientModule } from '@angular/common/http';
import { KontoComponent } from './kontos/konto/konto.component';
import { BuchungComponent } from './buchungen/buchung/buchung.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { BilanzComponent } from './bilanz/bilanz.component';
import { KontoCardComponent } from './kontos/konto-card/konto-card.component';
import { VermoegenComponent } from './vermoegen/vermoegen.component';
import { BuchungCardComponent } from './buchungen/buchung-card/buchung-card.component';
import { BuchungenHeaderComponent } from './buchungen/buchungen-header/buchungen-header.component';

@NgModule({
  declarations: [
    AppComponent,
    KontosComponent,
    BuchungenComponent,
    KontoComponent,
    BuchungComponent,
    SidebarComponent,
    HeaderComponent,
    BilanzComponent,
    KontoCardComponent,
    VermoegenComponent,
    BuchungCardComponent,
    BuchungenHeaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NbThemeModule.forRoot({ name: 'default' }), 
    NbSidebarModule.forRoot(), 
    NbMenuModule.forRoot(),
    NbToggleModule, 
    NbIconModule,
    NbSearchModule,
    NbActionsModule,
    NbCardModule,
    NbContextMenuModule,
    NbLayoutModule,
    NbEvaIconsModule,
    NbButtonModule, 
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
